<template>
  <div ref="myEcharts" :style="{ height, width }"></div>
</template>
<script>
import { ref, onMounted } from "vue";
import * as echarts from "echarts";
export default {
  name: "baseBar",
  props: {
    width: {
      type: String,
      default: "100%",
    },
    height: {
      type: String,
      default: "100%",
    },
    left2Data: {
      type: Object,
      default: () => {},
    }
  },
  setup(props) {
    // console.log(props);
    const myEcharts = ref(null);
    const chart = new InitChart(props, myEcharts);
    onMounted(() => {
      // console.log(props)
      chart.init(props.left2Data,props.name,props.color);
      
    });
    return {
      myEcharts,
    };
  },
};
class InitChart {
  constructor(props, myEcharts) {
    this.props = props;
    this.myEcharts = myEcharts;
    this.state = {
      chart: null,
    };
  }

  init() {
    this.state.chart && this.destory();
    this.state.chart = echarts.init(this.myEcharts.value);
     let list = [{
      name: '项目一',
      value: 50
    }, {
      name: '项目二',
      value: 25
    }, {
      name: '项目三',
      value: 30
    }, {
      name: '项目四',
      value: 25
    }, {
      name: '项目五',
      value: 30
    }];
    let yName = list.map((item) => item.name);
    let xData = list.map((item) => item.value);
    let barWidth = 14;

    this.state.chart.setOption({
       xAxis: {
        splitLine: {
          show: false
        },
        axisLabel: {
          show: false
        },
        axisTick: {
          show: false
        },
        axisLine: {
          show: false
        }
      },
      grid: {
        containLabel: true,
        left: 20,
        top: 15,
        right: 70,
        bottom: 15
      },
      yAxis: [{
        inverse: true,
        axisLine: {
          show: false
        },
        axisTick: {
          show: false
        },
        axisLabel: {
          margin: 10,
          textStyle: {
            fontSize: 14,
            color: '#fff'
          }
        },
        data: yName,
      }],
      series: [{ //内
        type: 'bar',
        barWidth,
        legendHoverLink: false,
        symbolRepeat: true,
        silent: true,
        itemStyle: {
          color: {
            type: 'linear',
            x: 0,
            y: 0,
            x2: 1,
            y2: 0,
            colorStops: [{
              offset: 0,
              color: 'rgba(7,208,163,0)' // 0% 处的颜色
            }, {
              offset: 1,
              color: 'rgba(7,208,163,1)' // 100% 处的颜色
            }]
          }
        },
        data: list,
        z: 1,
        animationEasing: 'elasticOut'
      },
      { // 背景
        type: 'pictorialBar',
        animationDuration: 0,
        symbolRepeat: 'fixed',
        symbolMargin: '20%',
        symbol: 'roundRect',
        symbolSize: [6, barWidth],
        itemStyle: {
          normal: {
            color: 'transparent',
          }
        },
        label: {
          normal: {
            show: true,
            position: 'right',
            offset: [0, 2],
            distance: 20,
            textStyle: {
              color: '#fff',
              fontSize: 13,
            },
            formatter: function (a, b) {
              console.log(a);
              console.log(b);
              return `${a.value}%`
            }
          },

        },
        data: xData,
        z: 0,
        animationEasing: 'elasticOut'
      },
      { //分隔
        type: 'pictorialBar',
        itemStyle: {
          color: '#00140E'
        },
        symbolRepeat: 'fixed',
        symbolMargin: 4,
        symbol: 'roundRect',
        symbolClip: true,
        symbolSize: [2, barWidth],
        symbolPosition: 'start',
        symbolOffset: [0, 0],
        data: list,
        z: 2,
        animationEasing: 'elasticOut'
      },
      ]
    });
    window.addEventListener("resize", () => {
      this.state.chart.resize();
    });
  }

  destory() {
    this.state.chart.dispose();
    window.removeEventListener("resize", () => {
      console.log("事件移除");
    });
  }
}
</script>
<style lang="less"></style>
